export const PatientResumeCompact = ({ metas, isConnected, getAnonymous, className = '' }) => {
    const hasCaseData = !!metas?.caseData;
    const patientName = hasCaseData ? metas.caseData.patient.patientName : '';
    const displayedPatientName = isConnected ? patientName : getAnonymous(patientName);
    const caseId = hasCaseData ? metas.caseData.caseID : '';
    const caseDate = hasCaseData ? metas.caseData.caseDate : '';

    return (
        <div className={`patient-resume-compact ${className}`}>
            <span>{displayedPatientName}</span>
            <span>{caseId}</span>
            <span>{caseDate}</span>
        </div>
    );
};
